import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-custom__header mb-4" }
const _hoisted_2 = { class: "dialog-custom__title" }
const _hoisted_3 = { class: "dialog-custom__content form-custom m-0" }
const _hoisted_4 = { style: {"width":"450px","height":"calc(100vh - 330px)"} }
const _hoisted_5 = { class: "dialog-custom__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContactTab = _resolveComponent("ContactTab")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_GateAccessTab = _resolveComponent("GateAccessTab")
  const _component_BadgeTab = _resolveComponent("BadgeTab")
  const _component_CodeTab = _resolveComponent("CodeTab")
  const _component_TabView = _resolveComponent("TabView")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isDialogVisible,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDialogVisible = $event)),
    onHide: _ctx.doHideDialog,
    modal: true,
    showHeader: false,
    closable: false,
    class: "dialog-custom add_guest_dialog"
  }, {
    default: _withCtx(() => [
      _createVNode("header", _hoisted_1, [
        _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.dialogTitle), 1)
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_TabView, { class: "p-tabview--custom" }, {
            default: _withCtx(() => [
              _createVNode(_component_TabPanel, {
                header: _ctx.$t('AppResourceEP.ContactTab')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ContactTab, {
                    isEdit: false,
                    editingGuest: _ctx.newGuest,
                    onContactEdited: _ctx.handleContactEdited,
                    onErrorContact: _ctx.handleErrorContact
                  }, null, 8, ["editingGuest", "onContactEdited", "onErrorContact"])
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_TabPanel, {
                header: _ctx.$t('AppResourceEP.GateAccessTab')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_GateAccessTab, {
                    isEdit: false,
                    editingGuest: _ctx.newGuest,
                    timesSlotsWithValidation: _ctx.timesSlots,
                    gates: _ctx.currentEntrancePlant.gates,
                    onGateAccessEdited: _ctx.handleGateAccesEdited,
                    onErrorGateAccess: _ctx.handleErrorGateAccess
                  }, null, 8, ["editingGuest", "timesSlotsWithValidation", "gates", "onGateAccessEdited", "onErrorGateAccess"])
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_TabPanel, {
                header: _ctx.$t('AppResourceEP.BadgeTab'),
                disabled: _ctx.isOneTime
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_BadgeTab, {
                    isEdit: false,
                    editingGuest: _ctx.newGuest,
                    onBadgeEdited: _ctx.handleBadgeEdited,
                    onErrorBadge: _ctx.handleErrorBadge
                  }, null, 8, ["editingGuest", "onBadgeEdited", "onErrorBadge"])
                ]),
                _: 1
              }, 8, ["header", "disabled"]),
              _createVNode(_component_TabPanel, {
                header: _ctx.$t('AppResourceEP.CodeTab')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CodeTab, {
                    isEdit: false,
                    editingGuest: _ctx.newGuest,
                    onKeyCodeEdited: _ctx.handleKeyCodeEdited,
                    onErrorKeyCode: _ctx.handleErrorKeyCode
                  }, null, 8, ["editingGuest", "onKeyCodeEdited", "onErrorKeyCode"])
                ]),
                _: 1
              }, 8, ["header"])
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("footer", _hoisted_5, [
        _createVNode(_component_Button, {
          class: "p-button-text mr-2",
          onClick: _ctx.handleHideDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Cancel")), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          label: _ctx.buttonSubmitLabel,
          onClick: _ctx.handleButtonSubmitAction,
          class: "p-button-rounded p-button-raised p-button--m",
          disabled: !_ctx.saveButtonEnable
        }, null, 8, ["label", "onClick", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onHide"]))
}